var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-56 border-b border-gray-700 w-full",attrs:{"id":_vm.domID},on:{"mouseenter":function($event){return _vm.$emit('select', _vm.ui)},"click":function($event){return _vm.$emit('select', _vm.ui)}}})}
var staticRenderFns = []

export { render, staticRenderFns }